import React, { useEffect, useState } from 'react'
import { getInitials } from '../../../utils/commonServices'
import { Avatar, Box, Collapse, IconButton, ListItemText, Menu, MenuList, Typography } from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { MenuItem } from '@mui/material';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import { useDispatch, useSelector } from 'react-redux';
import { updateTeamState } from '../../../redux/teamSlice';
import { useLocation, useNavigate } from 'react-router-dom';
import { updateProjectState } from '../../../redux/projectSlice';
import usePermissions from '../../../hooks/usePermissions';
import { PERMISSION } from '../../../constants/constants';
import { colors } from '../../../constants/staticData';
// import { customTheme as theme } from '../../../theme/customTheme';
import useCustomTheme from '../../../theme/useCustomTheme';
import useOrganisationProjectActions from '../useOrganisationProjectActions';

const ProjectMembersList = ({member, index, searchedArray, setTestmembers, roleOptions}) => {

  
    // const colorsCollaborator = ['#08231B', '#49A086', '#00CDFE'];
  
    const commonReducer = useSelector((state) => state.root.commonReducer);
    const permissionsReducer = useSelector((state) => state.permissionsReducer);
    const projectReducer = useSelector((state) => state.projectReducer);
    const dispatch = useDispatch()
    const location = useLocation()
    const navigate = useNavigate()
    const [hasPermission] = usePermissions();
    const [theme ] = useCustomTheme()

    // Get the member's organization role to display (organization roles take precedence)
    const orgMember = commonReducer?.organisation_members_list?.find(m => m.id === member?.internal_user_id);
    const displayRole = orgMember?.role_name || member?.role_name;

    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedRole, setSelectedRole] = useState(displayRole);

    // const roleOptions = ['Owner', 'Contributor', 'Filmer'];
    const [numberOfAdmins, setNumberOfAdmins] = useState(searchedArray.filter(member => member.role_name === 'Admin')?.length)

    const [numberOfProjectMembers, setNumberOfProjectMembers] = useState(searchedArray.filter(member => member.role_name === 'Admin')?.length)

    const {updateProjectMemberRole} = useOrganisationProjectActions()

    // useEffect(()=>{
    //   dispatch(updateProjectState({selected_member: member}))
    // },[member])

    useEffect(()=>{
      setSelectedRole(displayRole)
    },[displayRole, member])

    // console.log({numberOfAdmins})

    useEffect(()=>{
      setNumberOfAdmins(commonReducer?.selected_project_members?.filter(member => member.role_name === 'Admin')?.length)  
  },[searchedArray, commonReducer?.selected_project_members])
    
    
  
  
    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        event.stopPropagation()
        setAnchorEl(event.currentTarget);
    };

    const handleClose = (e) => {
        e.stopPropagation();
        setAnchorEl(null);
    };
  
    const handleRoleSelect = (role) => {  
      if (numberOfAdmins === 1 && member?.role_name === 'Admin'){
        // assign new project manager popup
        dispatch(updateProjectState({remove_owner_popup: true, invite_project_members_popup : false, change_project_admin_flag: true}))
      }else{
      const payload = {
          event_id: commonReducer?.production_event_id,
          internal_user_id: member?.internal_user_id,
          role_id: role?.id,
          organisation_id: commonReducer?.selected_organisation?.id
      }
      // console.log(payload)
      // console.log({role})
      updateProjectMemberRole(payload)
      // setSelectedRole(role.name);
     }
    setAnchorEl(null);
    };


    const handleDeleteMember =()=>{  
      if(member.role_name === 'Admin'){
        dispatch(updateProjectState({selected_member: member}))
        if (numberOfAdmins == 1) {
          dispatch(updateProjectState({remove_owner_popup : true}))
        } else {
          dispatch(updateProjectState({remove_user_confirmation_popup : true}))
        }
      }else{
        dispatch(updateProjectState({selected_member: member}))
        dispatch(updateProjectState({remove_user_confirmation_popup : true}))
      }
      dispatch(updateProjectState({invite_project_members_popup : false}))   
    }
  
   // Determine current user's role
   const currentUserIsAdmin = commonReducer?.role_name === 'Admin';
   const currentUserIsQC = commonReducer?.role_name === 'QC';
   const currentUserIsEditor = commonReducer?.role_name === 'Editor';
   
   // Determine if member is an Admin
   const memberIsAdmin = member?.role_name === 'Admin';
   
   // Determine if dropdown should be shown
   // Only Admin can change roles
   // QC and Editor can only view, cannot change roles
   const shouldShowDropdown = projectReducer.invite_project_members_popup && (
     currentUserIsAdmin // Only Admin can change anyone's role
   );

  return (
    <div style={{width:'90%'}} >
        {searchedArray?.length > 0 &&
            <>
            <Box mb={{xs:1, xl:3}} className='flex a-center' gap={2}>
    
                                <Avatar
                                    sx={{
                                    borderRadius: '5px',
                                    backgroundColor: colors[index % colors.length],
                                    color: 'white',
                                    width: { xs: '18px', sm: '20px', md: '22px', lg: '23.5px', xl: '35px' },
                                    height: { xs: '18px', sm: '20px', md: '22px', lg: '23.5px', xl: '35px' },
                                    paddingRight: 0,
                                    marginRight: 0,
                                    fontSize: { xs: '7px', md: '8px', lg: '8px', xl: '12px' },
                                    textTransform: 'uppercase',
                                    fontFamily: 'Rubik',
                                    fontWeight:600
                                    }}
                                >
                                    {getInitials(member.name)}
                                </Avatar>
                <Box flex={8} className='flex col' sx={{fontSize:{xs:'9px', md:'10px',lg:'13px', xl:'18px'}, fontWeight:600, color:'#000', fontFamily:'Rubik'}}>
                   {member.name}
                    <br />
                    {/* <span style={{fontSize:'10px', fontWeight:500}}>{member.email}</span> */}
                </Box>
             <Box flex={3} className='flex a-center' style={{justifyContent:'end', minWidth: '150px', gap: '8px'}}>
                    <Typography sx={{ fontSize: {xs:'9px', md:'10px',lg:'12px', xl:'16px'}, fontWeight: 500 , color:'#000000', fontFamily:'Rubik'}}>
                        {displayRole}
                    </Typography>
                
                    {currentUserIsAdmin && 
                    <IconButton 
                      disabled={projectReducer.is_loading} 
                      edge="end" 
                      onClick={(e) => {
                        e.stopPropagation();
                        handleDeleteMember();
                      }}
                      sx={{
                        padding: '4px',
                        '&:hover': {
                          backgroundColor: `${theme.palette.error.main}20`
                        }
                      }}
                    >
                      <Typography sx={{ fontSize: {xs:'14px', md:'16px',lg:'18px', xl:'20px'}, color: '#CE0101', fontWeight: 600 }}>×</Typography>
                    </IconButton>
                    }
                
                </Box>
            </Box>
     
            </>}
 
    </div>
  )
}

export default ProjectMembersList